import React from "react";

export const SacredMusic = ({size = 20, ...props}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 512 512"
            {...props}
        >
            <g fill="#785353">
                <path d="M123.863 474.839a8.258 8.258 0 01-7.379-11.952l57.806-115.613c2.048-4.085 7-5.742 11.081-3.694a8.258 8.258 0 013.694 11.081l-57.806 115.613a8.263 8.263 0 01-7.396 4.565zM388.137 474.839a8.257 8.257 0 01-7.395-4.565l-57.806-115.613a8.258 8.258 0 013.694-11.081c4.081-2.048 9.04-.391 11.081 3.694l57.806 115.613a8.258 8.258 0 01-7.38 11.952zM256 474.839a8.256 8.256 0 01-8.258-8.258V359.226c0-4.56 3.694-8.258 8.258-8.258s8.258 3.698 8.258 8.258v107.355a8.256 8.256 0 01-8.258 8.258z"></path>
            </g>
            <path
                fill="#d19a6e"
                d="M470.71 37.161H41.29a32.877 32.877 0 00-16.514 4.418L15 70.193V342.71h488.742V70.193c0-18.243-14.788-33.032-33.032-33.032z"
            ></path>
            <path
                fill="#fff"
                d="M462.452 70.193h-173.42a32.878 32.878 0 00-16.516 4.419L256 103.226c0-18.243-14.789-33.032-33.032-33.032H57.806a8.258 8.258 0 00-8.258 8.258v245.215H453l17.71-5.731V78.452a8.26 8.26 0 00-8.258-8.259z"
            ></path>
            <path
                fill="#f9eac7"
                d="M470.71 342.71v-24.774H297.29c-13.682 0-24.774-11.092-24.774-24.774V74.612C262.684 80.334 256 91.03 256 103.226v214.71H82.581c-13.682 0-24.774-11.092-24.774-24.774V70.194h-8.258a8.258 8.258 0 00-8.258 8.258V342.71z"
            ></path>
            <path
                fill="#b57f5f"
                d="M503.742 334.452H24.774V41.577C14.942 47.299 8.258 57.998 8.258 70.193v289.033h495.484a8.259 8.259 0 008.258-8.258v-8.258a8.258 8.258 0 00-8.258-8.258z"
            ></path>
            <path
                fill="#9f6e50"
                d="M33.032 350.968a8.258 8.258 0 01-8.258-8.258v-8.258H8.258A8.258 8.258 0 000 342.71v16.516a8.258 8.258 0 008.258 8.258h495.484a8.259 8.259 0 008.258-8.258v-8.258z"
            ></path>
            <path
                fill="#8ce1a4"
                d="M363.355 177.548v67.076c-2.595-.615-5.347-1.011-8.258-1.011-13.682 0-24.774 7.394-24.774 16.516 0 9.121 11.092 16.516 24.774 16.516s24.774-7.395 24.774-16.516V169.29z"
            ></path>
            <path
                fill="#9bd7ee"
                d="M215.427 127.145c-4.79-4-11.04-5.665-17.21-4.54l-55.484 10.089c-15.718 2.859-27.121 16.524-27.121 32.5v79.43c-2.595-.615-5.347-1.011-8.258-1.011-13.682 0-24.774 7.394-24.774 16.516 0 9.121 11.092 16.516 24.774 16.516s24.774-7.395 24.774-16.516v-70.694c0-14.769 5.702-21.586 13.556-23.013l55.484-10.089s5.282.667 5.282 11.175v60.6c-2.595-.615-5.347-1.011-8.258-1.011-13.682 0-24.774 7.394-24.774 16.516 0 9.121 11.092 16.516 24.774 16.516s24.774-7.395 24.774-16.516V143.266a20.95 20.95 0 00-7.539-16.121z"
            ></path>
            <path
                fill="#7dc3ee"
                d="M206.452 150.992c-.506-3.389-1.86-4.526-5.282-4.411l-55.484 10.089a16.504 16.504 0 00-13.556 16.25v16.516a16.505 16.505 0 0113.556-16.25l55.484-10.089c3.422-.114 4.776 1.021 5.282 4.411z"
            ></path>
            <path
                fill="#78c2a4"
                d="M383.697 140.818c-11.78 2.142-20.342 12.402-20.342 24.374v12.356l26.251-4.773a8.258 8.258 0 006.781-8.125v-21.193a4.129 4.129 0 00-4.868-4.062z"
            ></path>
        </svg>
    );
}

export default SacredMusic;